import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../api";
import { Numeral } from "../../components/Numeral";
import { ICargo, INftAsset } from "../../interfaces";
import { Utils } from "../../utils";

interface NftTopListProps {
  number: number
}
export const NftTopList = ({number}: NftTopListProps) => {
  const projectCode = 'NFT';
  const api = useApi(projectCode);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [mounted, setMounted] = useState<Boolean>(false);
  const [assets, setAssets] = useState<INftAsset[]>([]);

  useEffect(() => {
    if (mounted) return;
    setMounted(true);
    api.getNftTopTrades(number, (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setAssets(cargo.info);
      }
    })
  }, [api, mounted, number])

  return (
    <>
      <div className="container" style={{ maxWidth: '1000px' }}>
        <div className="d-flex flex-wrap align-items-center txt-14 text-gray-500 mx-auto">
          <div className="" style={{ flex: '3 1' }}>
            <span className="ms-3">{t('name')}</span>
          </div>
          <div className="volume text-right" style={{ flex: '1 1' }}>
            <span className="me-2 ms-3 ms-sm-0">volume(USD)</span>
          </div>
          <div className="d-none d-sm-block text-right me-2" style={{ flex: '1 1' }}>{t('price')}</div>
        </div>

        {assets.map((asset, index) => {
          if (asset.status !== 'S' && asset.status !== 'P') {
            return null;
          }
          return (
            <div key={asset.nftId} className="d-flex flex-wrap align-items-center mx-auto top8" onClick={() => {
              navigate(`/web/asset/detail/${asset.nftId}`)
            }}>
              <div className="d-flex align-items-center me-3" style={{ flex: '3 1' }}>
                <span className="text-end" style={{width:'20px'}}>{index + 1}</span>
                <img src={Utils().normalizeImagePath(asset.image, projectCode)} alt=""
                  className="mx-3" style={{ height: '30px', width: '30px', borderRadius: '50%' }} />
                <div className="w-100">
                  <div className="" style={{display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden'}}>{asset.name}</div>
                  <div className="d-block d-sm-none txt-12">底價：<Numeral value={asset.biddingPrice} /></div>
                </div>
              </div>

              <div className="d-flex flex-column flex-sm-row align-items-center justify-end weight-600 volume" style={{ flex: '1 1' }}>
                <span className="me-2 txt-14">{asset.tradeVolume && <Numeral value={asset.tradeVolume} />}</span>
                <span className="text-green-700 txt-12"></span>
              </div>
              <div className="d-none d-sm-block txt-14 weight-600 me-2 text-right" style={{ flex: '1 1' }}>
                {
                  asset.status === 'S' && <Numeral value={asset.sellingPrice} />
                }
                {
                  asset.status === 'P' && <Numeral value={asset.biddingPrice} />
                }
                </div>
            </div>
          )
        })}

      </div>

    </>
  )
}